import { SectionCard } from '@ingenico/react-ui/section-card';
import type { ReactNode } from 'react';
import type { DashboardRowDataType } from '../../model/merchant.model';
import { DashboardRowContent } from '../dashboard-row-content/DashboardRowContent';
import styles from './DashboardRow.module.scss';

export interface DashboardRowProps {
  readonly dashboardRowData: DashboardRowDataType;
}

export function DashboardRow({ dashboardRowData }: DashboardRowProps): ReactNode {
  return (
    <SectionCard
      customClassName={styles.dashboardRow__customClassName}
      title=""
      titleClassName={styles.dashboardRow__titleClassName}
    >
      <DashboardRowContent dashboardRowData={dashboardRowData} />
    </SectionCard>
  );
}
